module.exports = __webpack_public_path__ + "static/media/Chrome3.00b37209.gif";